export enum Edition {
  Express,
  Pro,
}

export function getEditionFromId(editionId: string | null | undefined, isPaidVersion = false): Edition {
  // Only an explicit 'pro' edition has the custom email-domain entitlement, with one
  // exception: grandfathered accounts that activated the Marketplace app before editions
  // existed have no edition value but are paid Pro accounts (the backend treats them as
  // Pro and never applies the Express email cap — see customer-voice _generate.py). They
  // are distinguished from Starter by isPaidVersion (a paid, active Marketplace
  // activation). Starter accounts also have no edition but are NOT paid; they must
  // resolve to Express so callers don't attempt Pro-only operations like reading the
  // email domain, which IAM denies for Starter with a 403 that hung the template editor.
  if (editionId === 'pro') {
    return Edition.Pro;
  }
  if (!editionId && isPaidVersion) {
    return Edition.Pro;
  }
  return Edition.Express;
}
